"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_FONT_FAMILY = exports.DEFAULT_FONT_WEIGHT_HEAVE = exports.DEFAULT_FONT_WEIGHT_LIGHT = exports.DEFAULT_FONT_WEIGHT_REGULAR = exports.DEFAULT_FONT_SIZE_NUMBER = exports.DEFAULT_FONT_SIZE = exports.TYPOGRAPHY = void 0;
/** *******************************************************************************************************************
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  
  Licensed under the Apache License, Version 2.0 (the "License").
  You may not use this file except in compliance with the License.
  You may obtain a copy of the License at
  
      http://www.apache.org/licenses/LICENSE-2.0
  
  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.                                                                              *
 ******************************************************************************************************************** */
exports.TYPOGRAPHY = {
    h1: {
        fontSize: '28px',
        fontWeight: 400,
        lineHeight: '40px',
        description: 'Page title',
    },
    h2: {
        fontSize: '18px',
        fontWeight: 700,
        lineHeight: '20px',
        description: 'Container title',
    },
    h3: {
        fontSize: '18px',
        fontWeight: 400,
        lineHeight: '20px',
        description: 'Card section header, Key/value pair column title, Help panel section header',
    },
    h4: {
        fontSize: '15px',
        fontWeight: 700,
        lineHeight: '20px',
        description: 'Paragraph title',
    },
    h5: {
        fontSize: '15px',
        fontWeight: 400,
        lineHeight: '20px',
        description: '-',
    },
    p: {
        fontSize: '14px',
        fontWeight: 400,
        lineHeight: '20px',
        description: 'Body and paragraph text',
    },
    a: {
        fontSize: '14px',
        fontWeight: 400,
        lineHeight: '20px',
        description: 'Normal links, Breadcrumb items',
    },
    kdd: {
        fontSize: '14px',
        fontWeight: 400,
        lineHeight: '20px',
        description: 'Displaying keyboard inputs',
    },
    pre: {
        fontSize: '14px',
        fontWeight: 400,
        lineHeight: '20px',
        description: 'Displaying preformatted blocks of code',
    },
    small: {
        fontSize: '12px',
        fontWeight: 400,
        lineHeight: '20px',
        description: 'Step labels in multipage create step navigation pane',
    },
    code: {
        fontSize: '12px',
        fontWeight: 400,
        lineHeight: '15px',
        description: 'Displaying code or computer output',
    },
};
exports.DEFAULT_FONT_SIZE = '14px';
exports.DEFAULT_FONT_SIZE_NUMBER = 14;
exports.DEFAULT_FONT_WEIGHT_REGULAR = 400;
exports.DEFAULT_FONT_WEIGHT_LIGHT = 300;
exports.DEFAULT_FONT_WEIGHT_HEAVE = 700;
exports.DEFAULT_FONT_FAMILY = '"Roboto", "Helvetica Neue", "HelveticaNeue", "Helvetica", "Arial", sans-serif';
//# sourceMappingURL=typography.js.map